module.exports = __webpack_public_path__ + "static/media/PC2-1.7d3edb22.jpg";